import React from 'react';
import {TextInput} from '../TextInput';

export class EmailInput extends TextInput {

    static defaultProps = {
        ...TextInput.dealtProps,
        autoComplete: 'email',
        type: 'email'
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/EmailInput/EmailInput.jsx